import isArray from 'lodash/isArray';
import last from 'lodash/last';
import {connect} from 'react-redux';

import withOverlayControls from 'eventbrite_design_system/structure/hoc/withOverlayControls';

import * as analytics from '@eb/site-analytics';
import {findTagByType} from '@eb/destination-utils';

import SearchHeader from '../components/SearchHeader';
import {
    getUserCurrentLocation as getUserCurrentLocationAction,
    searchLocationSuggestions as searchLocationSuggestionsAction,
} from '../actions/location';
import {
    handleApplyFilter as handleApplyFilterAction,
    handleRemoveFilter as handleRemoveFilterAction,
    searchAutocompleteSuggestions as searchAutocompleteSuggestionsAction,
    searchByBBoxOrPlace as searchByBBoxOrPlaceAction,
} from '../actions/search';
import {
    FORMAT_TAG_TYPE,
    CATEGORY_TAG_TYPE,
} from '../constants';
import {
    getSearchEventHeaderTitle,
    formatDateRangeStringForDisplay,
} from '../utils';

const {trackEventFromState} = analytics;

//If no date filter is applied the value will
//default to "current_future", if any filters
//are applied we will receive an array with
//both 'current_future' and whatever other
//filters. But that is only instance of more
//than one filter so we can feel safe returning
//the second option.
const _getSelectedDate = (date, {from: startDate, to: endDate} = {}) => {
    let dateToReturn;

    if (isArray(date)) {
        dateToReturn = last(date);
    }

    if (startDate && endDate) {
        dateToReturn = formatDateRangeStringForDisplay({startDate, endDate});
    }

    return dateToReturn;
};

const _getSelectedCategory = (tags) => findTagByType(CATEGORY_TAG_TYPE, tags);
const _getSelectedFormat = (tags) => findTagByType(FORMAT_TAG_TYPE, tags);

export const getSearchHeaderTitle = (state) => {
    if (state.botH1) {
        return state.botH1;
    }

    return getSearchEventHeaderTitle({
        currentPlace: state.location.currentPlace,
        currentPlaceParent: state.location.currentPlaceParent,
        placeType: state.location.placeType,
    }, {
        eventSearch: state.search.eventSearch,
    });
};

const _mapStateToProps = (state) => ({
    selectedPrice: state.search.eventSearch.price,
    selectedCategory: _getSelectedCategory(state.search.eventSearch.tags),
    selectedFormat: _getSelectedFormat(state.search.eventSearch.tags),
    selectedDate: _getSelectedDate(state.search.eventSearch.dates, state.search.eventSearch.dateRange),
    searchHeaderTitle: getSearchHeaderTitle(state),
    isBotRequest: state.app.isBotRequest,
    locationSlug: state.location.slug,
    currentPlace: state.location.currentPlace,
    term: state.search.eventSearch.q,
    locationDenied: state.location.locationDenied,
    currentLocationCoordinates: state.location.currentLocationCoordinates,
    suggestions: state.suggestions,
    isLoading: state.pagination.loading,
    trackGAEvent: (action) => trackEventFromState(state, action),
    location: state.location,
});

const _mapDispatchToProps = (dispatch, ownProps) => ({
    handleApplyFilter: (...args) => dispatch(handleApplyFilterAction(ownProps.history, ...args)),
    handleRemoveFilter: (...args) => dispatch(handleRemoveFilterAction(ownProps.history, ...args)),

    handleUseCurrentLocation: (...args) => dispatch(getUserCurrentLocationAction(ownProps.history, ...args)),

    handleLocationSuggestionChange: (...args) => dispatch(searchLocationSuggestionsAction(ownProps.history, ...args)),
    handleSearchSuggestionChange: (...args) => dispatch(searchAutocompleteSuggestionsAction(ownProps.history, ...args)),
    handleLocationSelect: (...args) => dispatch(searchByBBoxOrPlaceAction(ownProps.history, ...args)),
});

export default withOverlayControls(connect(
    _mapStateToProps,
    _mapDispatchToProps
)(SearchHeader));
